// Textos y traducción de errores de la pantalla de entrada compartida.
//
// FUENTE DE VERDAD. Se COPIA a cada app con scripts/sync-ui.sh junto a
// EntryScreen.jsx (que lo importa como './entryMessages'). Si se edita, correr
// el script para propagar; NO editar las copias de cada app.
//
// Va aparte del componente a propósito: es JS plano, sin React ni JSX, así que
// se prueba con `node --test` sin bundler ni jsdom.

// Supabase Auth responde en inglés ("Invalid login credentials"). El resto de la
// pantalla está en español y en usted; el error no tiene por qué ser la
// excepción, y de paso no se le revelan detalles del backend a quien esté
// probando contraseñas. Lo que no calza con ningún patrón cae en el genérico.
const MENSAJES = [
  [/invalid login credentials|invalid credentials/i, 'Correo o contraseña incorrectos.'],
  [/email not confirmed/i, 'La cuenta todavía no está confirmada. Avise a soporte.'],
  [/rate limit|too many requests/i, 'Demasiados intentos. Espere un momento e intente de nuevo.'],
  [/network|fetch|failed to/i, 'Sin conexión. Revise su internet e intente de nuevo.'],
];

export const traducirError = (mensaje = '') =>
  MENSAJES.find(([re]) => re.test(mensaje))?.[1] || 'No se pudo iniciar sesión. Intente de nuevo.';

export const HUB_URL = 'https://vlscr.net';

export const TEXTOS = {
  subtitulo: 'Acceso con su cuenta del sistema VLS',
  correo: 'Correo',
  clave: 'Contraseña',
  ingresar: 'Ingresar',
  ingresando: 'Ingresando…',
  cargando: 'Cargando…',
  olvido: 'Si olvidó su contraseña, pídale a un administrador del hub que la restablezca.',
  irAlHub: 'Ir al hub',
  salir: 'Salir',
  reintentar: 'Reintentar',
  // Title (tooltip) del logo, que enlaza al hub. Separado de irAlHub porque
  // ese es el texto de un botón visible y este es un atributo title, con
  // copy propio que nombra el parque.
  logoTitulo: 'Ir al hub Vista Los Sueños',
  // El correo se nombra porque el caso real es entrar con la cuenta equivocada:
  // sin verlo, la persona no entiende por qué le dicen que no tiene acceso.
  sinAcceso: (modulo, correo) =>
    correo
      ? `La cuenta ${correo} no tiene acceso a ${modulo}. Pídaselo a un administrador del hub.`
      : `Su cuenta no tiene acceso a ${modulo}. Pídaselo a un administrador del hub.`,
  // Aviso del estado "error": la consulta de rol FALLÓ (no contestó), a
  // diferencia de sinAcceso, que es cuando sí contestó y no hay membresía.
  // Ver resolverRol.js, que es quien distingue los dos casos.
  errorAviso: 'No pudimos verificar su acceso. Puede ser un problema de conexión.',
};
